import assetPath from '/app/packages/lebenslauf/constants/src/assets/template-1-2x.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')